import { combineReducers } from 'redux';

import * as sidebar from './sidebar';
import * as user from './user';

export const reducers = combineReducers({
    ...user.reducers,
    ...sidebar.reducers,
});

export const actions = {
    user: user.actions,
    sidebar: sidebar.actions,
};
